var _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuSport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1666,
    cy: 20.8334,
    r: 12.5,
    fill: "#5C5B5A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1666,
    cy: 20.8333,
    r: 7.08333,
    stroke: "#D1CFCD",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1666,
    cy: 20.8334,
    r: 2.5,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4785 12.6306L30.2959 6.81324C30.5497 6.55942 30.9804 6.64781 31.1137 6.98109L31.8321 8.77706L33.628 9.49544C33.9613 9.62876 34.0497 10.0594 33.7959 10.3132L27.9785 16.1306C27.8848 16.2244 27.7576 16.2771 27.625 16.2771H25.3887L20.1519 21.3845C19.8224 21.7059 19.2948 21.6993 18.9735 21.3698C18.6521 21.0403 18.6587 20.5127 18.9882 20.1914L24.3321 14.9795V12.9842C24.3321 12.8516 24.3848 12.7244 24.4785 12.6306Z",
    fill: "#FF791C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuSport);
export default __webpack_public_path__ + "static/media/wikiMenuSport.26202f6317cb89848b1ac7266db719b7.svg";
export { ForwardRef as ReactComponent };